/**
 * The Material icon set the AMP-Core team curates and ships in the public site
 * experience. Member values are the icon ligature names the public site icon
 * font recognises, so every id here is guaranteed to render as a glyph.
 */
export var AmpcoreMaterialIconId;
(function (AmpcoreMaterialIconId) {
    AmpcoreMaterialIconId["ARROW_DOWNWARD"] = "arrow_downward";
    AmpcoreMaterialIconId["ARROW_FORWARD"] = "arrow_forward";
    AmpcoreMaterialIconId["ARROW_UPWARD"] = "arrow_upward";
    AmpcoreMaterialIconId["CHECK"] = "check";
    AmpcoreMaterialIconId["CHEVRON_LEFT"] = "chevron_left";
    AmpcoreMaterialIconId["CHEVRON_RIGHT"] = "chevron_right";
    AmpcoreMaterialIconId["CLOSE"] = "close";
    AmpcoreMaterialIconId["KEYBOARD_CONTROL_KEY"] = "keyboard_control_key";
    AmpcoreMaterialIconId["LINK"] = "link";
    AmpcoreMaterialIconId["MAIL"] = "mail";
    AmpcoreMaterialIconId["MENU"] = "menu";
    AmpcoreMaterialIconId["MENU_OPEN"] = "menu_open";
    AmpcoreMaterialIconId["NEW_WINDOW"] = "new_window";
    AmpcoreMaterialIconId["PHONE"] = "phone";
    AmpcoreMaterialIconId["SEARCH"] = "search";
    AmpcoreMaterialIconId["SECURITY"] = "security";
    AmpcoreMaterialIconId["PICTURE_AS_PDF"] = "picture_as_pdf";
    AmpcoreMaterialIconId["EVENT_NOTE"] = "event_note";
    AmpcoreMaterialIconId["CHECK_PHONE"] = "security_update_good";
    AmpcoreMaterialIconId["SUPPORT_AGENT"] = "support_agent";
    AmpcoreMaterialIconId["RECEIPT"] = "receipt";
    AmpcoreMaterialIconId["COLLAPSE_ALL"] = "collapse_all";
    AmpcoreMaterialIconId["EXPAND_ALL"] = "expand_all";
    AmpcoreMaterialIconId["SUPPORT"] = "support";
    AmpcoreMaterialIconId["GROUPS"] = "groups";
    AmpcoreMaterialIconId["EXPAND_LESS"] = "expand_less";
    AmpcoreMaterialIconId["EXPAND_MORE"] = "expand_more";
    AmpcoreMaterialIconId["TUNE"] = "tune";
    AmpcoreMaterialIconId["FILTER_LIST"] = "filter_list";
    // Icons required by adel.amp.next.css
    AmpcoreMaterialIconId["ARROW_RIGHT_ALT"] = "arrow_right_alt";
    AmpcoreMaterialIconId["ATTACH_FILE"] = "attach_file";
    AmpcoreMaterialIconId["CHECK_BOX"] = "check_box";
    AmpcoreMaterialIconId["CHECK_BOX_OUTLINE_BLANK"] = "check_box_outline_blank";
    AmpcoreMaterialIconId["CHECK_CIRCLE"] = "check_circle";
    AmpcoreMaterialIconId["DONE"] = "done";
    AmpcoreMaterialIconId["EMERGENCY_HOME"] = "emergency_home";
    AmpcoreMaterialIconId["INDETERMINATE_CHECK_BOX"] = "indeterminate_check_box";
    AmpcoreMaterialIconId["INFO"] = "info";
    AmpcoreMaterialIconId["KEYBOARD_ARROW_UP"] = "keyboard_arrow_up";
    AmpcoreMaterialIconId["KEYBOARD_ARROW_DOWN"] = "keyboard_arrow_down";
    AmpcoreMaterialIconId["KEYBOARD_ARROW_LEFT"] = "keyboard_arrow_left";
    AmpcoreMaterialIconId["KEYBOARD_ARROW_RIGHT"] = "keyboard_arrow_right";
    AmpcoreMaterialIconId["OPEN_IN_NEW"] = "open_in_new";
    AmpcoreMaterialIconId["WARNING"] = "warning";
    // used by prospect site https://www.ameriprise.com/guest-nx presently
    AmpcoreMaterialIconId["REPORT_GMAILERRORRED"] = "report_gmailerrorred";
    // used by OCS login
    AmpcoreMaterialIconId["PASSKEY"] = "passkey";
    AmpcoreMaterialIconId["ARROW_BACK_IOS"] = "arrow_back_ios";
})(AmpcoreMaterialIconId || (AmpcoreMaterialIconId = {}));
